/**
 * 铸剑阁难度系统（Task 2）
 *
 * 从关卡配置文件读取难度值（1-5）
 * 支持多章节关卡配置
 */

/**
 * 获取关卡难度等级
 *
 * @param _chapterNum - 章节号（1-5）（预留参数，当前未使用）
 * @param levelId - 关卡 ID（如 "v5_0-1_first_contact"）
 * @returns 难度等级（1-5），默认 1
 *
 * 数据来源：data/levels/_builtin/{levelId}/mission.json
 * 如果找不到配置，返回默认值 1
 */
export function getForgeLevelDifficulty(
  _chapterNum: number,
  levelId: string
): number {
  try {
    // 尝试从全局 LEVEL_REGISTRY 读取（如果存在）
    if (typeof (window as any).LEVEL_REGISTRY !== "undefined") {
      const registry = (window as any).LEVEL_REGISTRY;
      const level = registry[levelId];
      if (level && typeof level.difficulty === "number") {
        return Math.max(1, Math.min(5, level.difficulty));
      }
    }

    // 备选：从 sessionStorage 读取（屏 12 可能缓存了配置）
    const cached = sessionStorage.getItem(`battlecode-level-${levelId}`);
    if (cached) {
      try {
        const config = JSON.parse(cached);
        if (typeof config.difficulty === "number") {
          return Math.max(1, Math.min(5, config.difficulty));
        }
      } catch {
        // 缓存解析失败，继续
      }
    }

    // 默认值
    return 1;
  } catch (err) {
    console.warn(`[forge-difficulty] 获取关卡 ${levelId} 难度失败:`, err);
    return 1;
  }
}

/**
 * 获取关卡最大时间
 *
 * @param _chapterNum - 章节号（1-5）（预留参数，当前未使用）
 * @param levelId - 关卡 ID
 * @returns 最大时间（ticks），默认 1800
 *
 * 数据来源：data/levels/_builtin/{levelId}/mission.json
 * 如果找不到配置，返回默认值 1800 ticks（60 秒 @ 30Hz）
 */
export function getMaxTimeForLevel(
  _chapterNum: number,
  levelId: string
): number {
  try {
    // 尝试从全局 LEVEL_REGISTRY 读取
    if (typeof (window as any).LEVEL_REGISTRY !== "undefined") {
      const registry = (window as any).LEVEL_REGISTRY;
      const level = registry[levelId];
      if (level && typeof level.maxTime === "number") {
        return Math.max(300, level.maxTime); // 最少 10 秒
      }
    }

    // 备选：从 sessionStorage 读取
    const cached = sessionStorage.getItem(`battlecode-level-${levelId}`);
    if (cached) {
      try {
        const config = JSON.parse(cached);
        if (typeof config.maxTime === "number") {
          return Math.max(300, config.maxTime);
        }
      } catch {
        // 缓存解析失败，继续
      }
    }

    // 默认值：1800 ticks = 60 秒 @ 30Hz
    return 1800;
  } catch (err) {
    console.warn(`[forge-difficulty] 获取关卡 ${levelId} 最大时间失败:`, err);
    return 1800;
  }
}
